import { Component, OnInit } from '@angular/core';  
import { MatDialogRef } from '@angular/material/dialog'; 

@Component({
  selector: 'hour4u-admin-first-time-login',
  templateUrl: './first-time-login.component.html',
  styleUrls: ['./first-time-login.component.scss']
})
export class FirstTimeLoginComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<FirstTimeLoginComponent>){}

  ngOnInit() {
  }

  close(){
    this.dialogRef.close();
  }
}
